import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import CancelationPolicy from 'cms/faqs/Article/Policy/CancelationPolicy';
import OpenPolicy from 'cms/faqs/Article/Policy/OpenPolicy';

const Policy = ({companyName, cancellationPolicies, openPolicies, nonRefundableClasses, translations}) => {
  const nOfClasses = nonRefundableClasses.length;
  const {
    cancelChangeProcedure, cancelChangeProcedureText, exceptions, cancelPolicyClass,
    cancelPolicyClasses, noShows, cancelPolicyNonTicket
  } = translations;

  return (
    <Fragment>
      <p>
        <span className="font-bold d-block">{cancelChangeProcedure}</span>
        {cancelChangeProcedureText}
      </p>
      {
        cancellationPolicies.length > 0 &&
          <CancelationPolicy
            companyName={companyName}
            policies={cancellationPolicies}
            translations={translations}
          />
      }
      <p>
        {
          nOfClasses > 0 && <Fragment>
            {exceptions}:<br/>
            {
              `${(nOfClasses === 1 ? cancelPolicyClass : cancelPolicyClasses)
                .replace('{class}', nonRefundableClasses.join(', '))}`
            }
          </Fragment>
        }
      </p>
      {
        openPolicies.length > 0 &&
          <OpenPolicy
            companyName={companyName}
            policies={openPolicies}
            translations={translations}
          />
      }
      <p>
        <span className="font-bold d-block">{noShows}</span>
        {cancelPolicyNonTicket}
      </p>
    </Fragment>
  );
};

Policy.propTypes = {
  companyName: PropTypes.string.isRequired,
  cancellationPolicies: PropTypes.object.isRequired,
  openPolicies: PropTypes.object.isRequired,
  nonRefundableClasses: PropTypes.object.isRequired,
  translations: PropTypes.shape({
    cancelChangeProcedure: PropTypes.string.isRequired,
    cancelChangeProcedureText: PropTypes.string.isRequired,
    exceptions: PropTypes.string.isRequired,
    cancelPolicyClass: PropTypes.string.isRequired,
    cancelPolicyClasses: PropTypes.string.isRequired,
    noShows: PropTypes.string.isRequired,
    cancelPolicyNonTicket: PropTypes.string.isRequired
  }).isRequired
};

export default observer(Policy);
